import * as React from 'react';
import classNames from 'classnames';
import { CnCheckbox } from './cn-checkbox';
import isFunction from 'lodash/isFunction';
import isNumber from 'lodash/isNumber';
import isString from 'lodash/isString';
import { getDataSourceFromChildren, isValidArray } from '@/utils/func';
import { useValue } from '@/utils/use-value';
import { getItemsFromDataSource } from '@/utils/tree';
import { useFormLayout } from '@/form/cn-form-layout';
import { CnReadonly } from '@/components/cn-readonly';
import './cn-checkbox-group.scss';
export const CnCheckboxGroup = (props) => {
    const { size, direction, defaultValue, dataSource, className, onChange, disabled, children, readOnly, readOnlyRender, value: valueProp, ...others } = props;
    const prefix = 'cn-ui-m-';
    const { labelAlign } = useFormLayout();
    const [value, setValue, isControlled] = useValue(props, [], {
        fitValue: (v) => {
            if (v && !Array.isArray(v)) {
                return [v];
            }
            if (!isValidArray(v)) {
                return [];
            }
            return v;
        },
        compare: (a, b) => {
            return a.toString() === b.toString();
        },
    });
    const handleChange = React.useCallback((selected, checkBoxValue, e) => {
        // 取消选中
        if (!selected) {
            const index = value.indexOf(checkBoxValue);
            const newGroup = [...value];
            if (index >= 0) {
                newGroup.splice(index, 1);
                if (!isControlled) {
                    setValue(newGroup);
                }
            }
            if (!disabled && !readOnly && onChange) {
                onChange(newGroup, e);
            }
        }
        // 选中
        if (!disabled && !readOnly && selected) {
            const newGroup = [...value, checkBoxValue];
            if (!isControlled) {
                setValue(newGroup);
            }
            if (onChange) {
                onChange(newGroup, e);
            }
        }
    }, [value, setValue, isControlled, onChange]);
    let content;
    let ds = dataSource;
    if (!ds && React.Children.count(children) > 0) {
        ds = getDataSourceFromChildren(children);
    }
    if (Array.isArray(ds) && ds.length > 0) {
        content = ds.map((item, index) => {
            let itemData = {
                style: {},
                value: null,
                checked: false,
                label: '',
                text: '',
                disabled: false,
                size,
            };
            const { onClick: itemOnClick, onChange: itemOnChange, className: itemClassName, label: itemLabel, text: itemText, ...itemRest } = item;
            if (isString(item) || isNumber(item)) {
                itemData.value = item;
            }
            else {
                itemData = { ...itemData, ...itemRest };
            }
            const label = itemLabel || itemText || itemData.value;
            const isLast = index === ds.length - 1;
            return (React.createElement(CnCheckbox, { ...itemData, key: `cnuim_ck_${index}`, className: classNames(itemClassName, {
                    [`${prefix}checkbox-item--${direction}-${size}`]: !isLast,
                }), style: itemData.style, onChange: (selected, e) => handleChange(selected, itemData.value, e), checked: itemData.checked || value.includes(itemData.value), disabled: disabled || itemData.disabled, onClick: itemOnClick }, label));
        });
    }
    if (readOnly) {
        if (isFunction(readOnlyRender)) {
            return React.createElement("div", null, "readOnlyRender(getItemsFromDataSource(ds, value))");
        }
        return (React.createElement(CnReadonly, null, getItemsFromDataSource(ds, value)
            .map((v) => v.label || v.text)
            .join(',')));
    }
    return (React.createElement("div", { className: classNames(className, `${prefix}checkbox-group`, `${prefix}checkbox-group--${direction}`, `${prefix}checkbox-group--${labelAlign}-${size}`), ...others }, content));
};
CnCheckboxGroup.displayName = 'CnCheckboxGroup';
CnCheckboxGroup.defaultProps = {
    size: 'medium',
    direction: 'ver',
};
